import { LayoutDashboard, Users, Calendar, Clock, DollarSign, ShoppingCart, BarChart2, Store, Settings, Smartphone, Star, FileBarChart, ClipboardCheck, Wallet, FileText, Bell } from 'lucide-react';

const item = (id, label, Icon, group) => ({ id, label, Icon, group });
export function navigationItems(role, hasLocation) {
  const privileged = role === 'admin' || role === 'general_manager';
  if (privileged && !hasLocation) return [
    item('dashboard', 'Overview', LayoutDashboard, 'Operations'),
    item('audits', 'Checklists', ClipboardCheck, 'Operations'),
    item('visits', 'Visits', Star, 'Operations'),
    item('people', 'People', Users, 'People'),
    item('managers', 'Manager accounts', Users, 'People'),
    item('profits', 'Financials', FileBarChart, 'Finances'),
    ...(role === 'admin' ? [item('restaurants', 'Locations', Store, 'Settings')] : []),
    item('settings', 'Settings & records', Settings, 'Settings'),
    item('kiosklinks', 'Kiosk access', Smartphone, 'Settings'),
    item('notifications', 'Notifications', Bell, 'Settings'),
  ];
  return [
    item('dashboard', 'Today', LayoutDashboard, 'Daily operations'),
    item('schedule', 'Schedule', Calendar, 'Daily operations'),
    item('clockin', 'Attendance', Clock, 'Daily operations'),
    item('approvals', 'Approvals', ClipboardCheck, 'Daily operations'),
    item('vendor', 'Vendor orders', ShoppingCart, 'Daily operations'),
    item('cashouts', 'Cash-outs', Wallet, 'Daily operations'),
    item('audits', 'Checklists', ClipboardCheck, 'Daily operations'),
    item('employees', 'People', Users, 'People'),
    item('timesheets', 'Timesheets', FileText, 'People'),
    item('payroll', 'Payroll', DollarSign, 'Finances'),
    ...(privileged ? [item('monthlypnl', 'Financials', FileBarChart, 'Finances')] : []),
    item('reports', 'Reports', BarChart2, 'Finances'),
    item('settings', 'Location settings', Settings, 'Settings'),
    item('notifications', 'Notifications', Bell, 'Settings'),
  ];
}
